"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("../Base");

var _Input = _interopRequireDefault(require("../Input"));

var _l10n = _interopRequireDefault(require("../../common/l10n"));

var _wrapper = _interopRequireDefault(require("./style/cardholder/wrapper"));

var _firstName = _interopRequireDefault(require("./style/cardholder/firstName"));

var _lastName = _interopRequireDefault(require("./style/cardholder/lastName"));

var _errorWrapper = _interopRequireDefault(require("./style/manual/errorWrapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var firstNameDefaultProps = {
  floating: false,
  label: 'DEBIT_SOURCE_WALLET_LABEL_CARDHOLDER_FIRST_NAME',
  placeholder: 'TARAS',
  maxLength: 20
};
var lastNameDefaultProps = {
  floating: false,
  label: 'DEBIT_SOURCE_WALLET_LABEL_CARDHOLDER_LAST_NAME',
  placeholder: 'SHEVCHENKO',
  maxLength: 20
};

var cardholderFormat = function cardholderFormat(value) {
  return value ? value.replace(/[^a-zа-яґїє'-]/gi, '') : null;
};

var Cardholder = function Cardholder(_ref) {
  var theme = _ref.theme,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      disabled = _ref.disabled;

  var _useMemo = (0, _react.useMemo)(function () {
    return [_objectSpread({}, firstNameDefaultProps, {
      label: _l10n["default"].t(firstNameDefaultProps.label),
      placeholder: _l10n["default"].t(firstNameDefaultProps.placeholder)
    }, firstName, {
      disabled: disabled
    }), _objectSpread({}, lastNameDefaultProps, {
      label: _l10n["default"].t(lastNameDefaultProps.label),
      placeholder: _l10n["default"].t(lastNameDefaultProps.placeholder)
    }, lastName, {
      disabled: disabled
    })];
  }, [firstName, lastName, disabled]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      firstNameProps = _useMemo2[0],
      lastNameProps = _useMemo2[1];

  var onFirstNameChange = (0, _react.useCallback)(function (event) {
    if (typeof firstName.onChange === 'function') {
      firstName.onChange(cardholderFormat(event.target.value));
    }
  }, [firstName.onChange]);
  var onLastNameChange = (0, _react.useCallback)(function (event) {
    if (typeof lastName.onChange === 'function') {
      lastName.onChange(cardholderFormat(event.target.value));
    }
  }, [lastName.onChange]);
  var firstNameStyle = (0, _react.useMemo)(function () {
    return _objectSpread({
      width: '100%',
      textTransform: 'uppercase'
    }, firstNameProps.style);
  }, [firstNameProps.style]);
  var lastNameStyle = (0, _react.useMemo)(function () {
    return _objectSpread({
      width: '100%',
      textTransform: 'uppercase'
    }, lastNameProps.style);
  }, [lastNameProps.style]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_wrapper["default"], {
    theme: theme
  }, _react["default"].createElement(_firstName["default"], {
    theme: theme
  }, _react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, firstNameProps, {
    onChange: onFirstNameChange,
    value: cardholderFormat(firstName.value),
    error: !!firstNameProps.error,
    style: firstNameStyle,
    ref: firstNameProps.elementRef
  }))), _react["default"].createElement(_lastName["default"], {
    theme: theme
  }, _react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, lastNameProps, {
    onChange: onLastNameChange,
    value: cardholderFormat(lastName.value),
    error: !!lastNameProps.error,
    style: lastNameStyle,
    ref: lastNameProps.elementRef
  })))), _react["default"].createElement(_errorWrapper["default"], null, _react["default"].createElement(_Base.FieldError, {
    error: firstName.error
  }), _react["default"].createElement(_Base.FieldError, {
    error: lastName.error
  })));
};

Cardholder.propTypes = {
  theme: _propTypes["default"].object,
  firstName: _propTypes["default"].object,
  lastName: _propTypes["default"].object,
  disabled: _propTypes["default"].bool
};
var _default = Cardholder;
exports["default"] = _default;